/**
 * User Profile API Service
 *
 * Handles user profile update operations.
 * Uses the existing /auth/update-profile endpoint.
 */

import { apiClient } from '../../../core/config/api';
import type { User } from '../types/auth';

/**
 * Request payload for profile updates.
 * Only include fields you want to update.
 */
export interface ProfileUpdateRequest {
  first_name?: string;
  last_name?: string;
  display_name?: string;
  timezone?: string;
  primary_language?: string;
  default_framework_id?: string | null;
  default_pedagogical_model_ids?: string[];
}

/**
 * Response from profile update endpoint
 */
export interface ProfileUpdateResponse {
  user: User;
  message: string;
  updated_fields: string[];
}

export const profileApi = {
  /**
   * Update current user's profile
   *
   * @param data - Partial profile data to update
   * @returns Updated user data with list of updated fields
   */
  updateProfile: async (data: ProfileUpdateRequest): Promise<ProfileUpdateResponse> => {
    const response = await apiClient.post<ProfileUpdateResponse>('/auth/update-profile', data);
    return response.data;
  },
};

export default profileApi;
